import {Component, Inject, Input} from '@angular/core';
import {FormArray, FormBuilder, FormGroup} from '@angular/forms';
import {ENVIRONMENT, EnvironmentBroker, PersonInsurance} from '@emma-labs/shared/typescript';
import {CardModule} from 'primeng/card';
import {SaleReport} from '../../../entities/page-shared-object/sale-report';
import {InsuranceForm, SaleReportForm} from '../../../entities/page-shared-object/sale-report-form';
import {BaseSectionComponent} from '../../base-section/base-section.component';
import {SaleReportComponent} from '../../sale-reports/sale-report.component';

@Component({
  selector: 'em-sale-reports-section',
  templateUrl: './sale-reports-section.component.html',
  imports: [CardModule, SaleReportComponent],
})
export class SaleReportsSectionComponent extends BaseSectionComponent<
  FormArray<FormGroup<SaleReportForm>>,
  SaleReport[]
> {
  @Input({required: true})
  override set props(saleReports: SaleReport[] | undefined) {
    if (!this.isPropsReceived && saleReports) {
      saleReports.forEach((saleReport) => {
        const formGroup = this.createForm(saleReport.protection.personInsurances);
        this.form.push(formGroup, {emitEvent: false});
      });

      super.props = saleReports;
    }
  }

  @Input() title: string | undefined;

  constructor(
    private readonly fb: FormBuilder,
    @Inject(ENVIRONMENT) environment: EnvironmentBroker,
  ) {
    super(environment);

    this.form = fb.array<FormGroup<SaleReportForm>>([]);
  }

  private createForm(insurances: PersonInsurance[]): FormGroup<SaleReportForm> {
    const insuranceForms = insurances.map(() => this.createInsuranceForm());

    return this.fb.group<SaleReportForm>({
      id: this.fb.control(null),
      insurer: this.fb.control(null),
      insurances: this.fb.array<FormGroup<InsuranceForm>>(insuranceForms),
      fullName: this.fb.control(null),
      policyNumber: this.fb.control(null),
      status: this.fb.control(null),
      type: this.fb.control(null),
      agent: this.fb.control(null),
      proposalLink: this.fb.control(null),
      hasReplacementNotice: this.fb.control(null),
      canDownloadContract: this.fb.control(null),
      canAccessProposal: this.fb.control(null),
      secretCode: this.fb.control({value: null, disabled: true}),
    });
  }

  private createInsuranceForm(): FormGroup<InsuranceForm> {
    return this.fb.group<InsuranceForm>({
      annualPremium: this.fb.control(null),
      coverage: this.fb.control(null),
      insuranceType: this.fb.control(null),
      duration: this.fb.control(null),
    });
  }
}
